"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePinDesignators = normalizePinDesignators;
exports.derivePhysicalPinCount = derivePhysicalPinCount;
exports.inferPinCountFromDefinition = inferPinCountFromDefinition;
exports.resolveSeedPinCount = resolveSeedPinCount;
function normalizePinDesignators(pins) {
    return pins.map((pin) => pin.trim()).filter((pin) => pin !== '');
}
function derivePhysicalPinCount(pinout, additionalPins = []) {
    const uniquePins = new Set();
    for (const pins of Object.values(pinout)) {
        for (const designator of normalizePinDesignators(pins)) {
            uniquePins.add(designator);
        }
    }
    for (const designator of normalizePinDesignators(additionalPins)) {
        uniquePins.add(designator);
    }
    return uniquePins.size < 2 ? null : uniquePins.size;
}
function inferPinCountFromDefinition(definition) {
    if (definition === null) {
        return null;
    }
    if (definition.repeatableBlocks.length > 0) {
        return null;
    }
    if (definition.signals.some((signal) => signal.isOptional)) {
        return null;
    }
    if (definition.signals.length < 2) {
        return null;
    }
    return definition.signals.length;
}
function resolveSeedPinCount(definition, pinout, noConnectPins = []) {
    const inferred = inferPinCountFromDefinition(definition);
    const derived = derivePhysicalPinCount(pinout, noConnectPins);
    if (inferred === null) {
        return derived;
    }
    if (derived === null) {
        return inferred;
    }
    return Math.max(inferred, derived);
}
//# sourceMappingURL=pin-count-rules.js.map